import type { DriveStep } from 'driver.js';

export const caseReviewTourSteps: DriveStep[] = [
  {
    element: '[data-onboarding="case-nav"]',
    popover: {
      title: 'Case Navigation',
      description: 'Use the arrows to move between cases without going back to the dashboard. The case number links to the Salesforce record.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="case-metadata"]',
    popover: {
      title: 'Case Information',
      description: 'Shows the detected language and page count. This helps you verify the translation scope.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="status-dropdown"]',
    popover: {
      title: 'Status Control',
      description: 'View and change the case status. You can manually move cases between "Ready for Review" and "Approved" statuses when needed.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-onboarding="history-btn"]',
    popover: {
      title: 'Case History',
      description: 'View the complete history of status changes and HTML edits. You can see diffs of what was changed in each edit.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="sf-status-btn"]',
    popover: {
      title: 'Salesforce Status',
      description: 'Check the current status of this case in Salesforce. Useful to verify if the case is still in the Translation queue.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="translate-btn"]',
    popover: {
      title: 'Translate / Re-translate',
      description: 'Start or restart the translation. If a translation exists, this will replace it with a new one using the current AI settings.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="restart-btn"]',
    popover: {
      title: 'Restart Case',
      description: 'WARNING: This deletes all local files and re-downloads from Salesforce. Use this when the source documents have changed. Case history is preserved.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="original-pane"]',
    popover: {
      title: 'Original Document',
      description: 'The source PDF from Salesforce. Use this to compare against the translation. Click the pop-out button to open in a separate window.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="translated-pane"]',
    popover: {
      title: 'Translated Document',
      description: 'The AI-generated translation. By default shows the PDF, but you can switch to HTML editing mode.',
      side: 'left',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="edit-btn"]',
    popover: {
      title: 'Edit Translation',
      description: 'Switch to HTML editing mode. Make corrections to the translation text, then save. The PDF will automatically regenerate.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="regen-pdf-btn"]',
    popover: {
      title: 'Regenerate PDF',
      description: 'Manually regenerate the PDF from the current HTML. Useful if the PDF looks different than expected.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="export-btn"]',
    popover: {
      title: 'Export Options',
      description: 'Download the translation as:\n- Word (.docx) - Editable document\n- HTML - Raw translation markup',
      side: 'bottom',
      align: 'end',
    },
  },
  {
    element: '[data-onboarding="approve-btn"]',
    popover: {
      title: 'Approve Translation',
      description: 'When the translation is correct, click Approve to move it to the Approved queue. It will then be ready for upload to Salesforce.',
      side: 'left',
      align: 'center',
    },
  },
  {
    popover: {
      title: 'Review Workflow',
      description: 'Typical review process:\n\n1. Compare original vs translation\n2. Make edits if needed (HTML mode)\n3. Verify the PDF looks correct\n4. Click Approve when satisfied\n\nThe case then moves to the Approved section for upload.',
      side: 'over',
      align: 'center',
    },
  },
];
